import type { InboxEntry, TicketArtifact } from '@this+that/models';

import { toServedList } from './listTicketRuns';

type TicketArtifactsField = InboxEntry['ticketArtifacts'];

function keepKnownSlug(
  artifact: TicketArtifact,
  knownSlugById: ReadonlyMap<string, string>,
): TicketArtifact {
  const knownSlug = knownSlugById.get(artifact.id);
  if (
    !artifact.pullRequest ||
    artifact.pullRequest.repositorySlug ||
    !knownSlug
  ) {
    return artifact;
  }
  return {
    ...artifact,
    pullRequest: { ...artifact.pullRequest, repositorySlug: knownSlug },
  };
}

/** A socket push carries the artifacts without `repositorySlug` for a viewer who did not
 *  delegate the producing run, but a viewer who did already holds it from GraphQL: the merge keeps
 *  that slug on an artifact the push repeats. An absent field stays absent (the ticket has none),
 *  and an artifact the push no longer lists is dropped. */
export function mergeTicketArtifacts(
  incoming: TicketArtifactsField,
  held: TicketArtifactsField,
): TicketArtifactsField {
  if (incoming == null) {
    return incoming;
  }
  const knownSlugById = new Map<string, string>();
  for (const artifact of toServedList<TicketArtifact>(held)) {
    if (artifact.pullRequest?.repositorySlug) {
      knownSlugById.set(artifact.id, artifact.pullRequest.repositorySlug);
    }
  }
  if (knownSlugById.size === 0) {
    return incoming;
  }
  const merged = toServedList<TicketArtifact>(incoming).map((artifact) =>
    keepKnownSlug(artifact, knownSlugById),
  );
  return merged as unknown as TicketArtifactsField;
}
